import { SvgConsumer } from '@components/icons/svgConsumer';
import { Button } from '@components/ui/button';
import { Checkbox } from '@components/ui/checkbox';
import { FormField } from '@components/ui/form';
import { FormItemWrapper } from '@components/ui/form/itemWrapper';
import { AppTooltip } from '@components/ui/tooltip/tooltip';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { RelatedSchedulesDialogActionsProps } from './types';
import { useRescheduler } from '@contexts/rescheduler';

export const RelatedSchedulesDialogActions = ({
  data,
  onRemove,
  onEdit,
}: RelatedSchedulesDialogActionsProps) => {
  const { t } = useTranslation('app');
  const { isSavedSchedule, removeSavedSchedule } = useRescheduler();
  const { control } = useFormContext<{ confirmed: boolean }>();

  const disabled = isSavedSchedule(data);

  return (
    <div className="flex items-center justify-between">
      <FormField
        control={control}
        name="confirmed"
        render={({ field: { value, onChange, ...rest } }) => (
          <FormItemWrapper>
            <Checkbox
              {...rest}
              disabled={false}
              checked={value}
              onCheckedChange={(v) => {
                removeSavedSchedule(data);
                onChange(v);
              }}>
              <div className="flex items-center gap-2">
                {t('forms.confirmed.label')}
                <AppTooltip side="top" context={<p>{t('schedules.confirmedTooltip')}</p>}>
                  <span>
                    <SvgConsumer className="text-m text-neutral-500" id="tooltip" />
                  </span>
                </AppTooltip>
              </div>
            </Checkbox>
          </FormItemWrapper>
        )}
      />
      <div className="flex items-center gap-2.5">
        <AppTooltip side="top" context={<p>{t('relatedSchedules.tooltip.remove')}</p>}>
          <Button onClick={onRemove} size="sm" variant="dangerSecondary" className="w-8 p-0">
            <SvgConsumer id="trash" />
          </Button>
        </AppTooltip>
        <Button onClick={onEdit} size="sm" variant="secondary">
          {t('actions.edit')}
        </Button>
        <Button
          disabled={disabled}
          type="submit"
          size="sm"
          variant={disabled ? 'successSecondary' : undefined}>
          {disabled && <SvgConsumer id="completed" />}
          {t(`actions.${disabled ? 'updated' : 'save'}`)}
        </Button>
      </div>
    </div>
  );
};
